module.exports = __webpack_public_path__ + "img/b_airteltigo@2x.ac874d3d.png";